import * as React from 'react';
import { useSelector } from 'react-redux';
import { splitEvery } from 'ramda';
import { getNewBuildingApartments } from '../../selectors';
import { ApartmentsListGroup as ApartmentsListGroupComponent } from '../../components/ApartmentsList';
import { IApplicationState } from '../../types/redux';

interface IRoomsListProps {
  newBuildingId: number;
}

const MAX_APARTMENTS_LINE = 3;

export function ApartmentsListGroup({ newBuildingId }: IRoomsListProps) {
  const apartments = useSelector((state: IApplicationState) => getNewBuildingApartments(state, newBuildingId));
  const groups = React.useMemo(() => splitEvery(MAX_APARTMENTS_LINE, apartments), [apartments]);

  return <ApartmentsListGroupComponent groups={groups} />;
}
